import { Api } from '../api';
import { resources } from '../endpoints';
import type { ResourceEntity } from './models';

export class ResourcesApi extends Api {
  static getRepository = (signal?: AbortSignal) => this.get<ResourceEntity[]>(resources.getRepository(), { signal });

  static downloadFile = (id: string, signal?: AbortSignal) =>
    this.get<Blob>(resources.download(id), { headers: { Accept: 'application/pdf' }, responseType: 'blob', signal });
}
